import { Document, Page, pdfjs } from 'react-pdf';
import { useEffect, useRef, useState } from 'react';

// react-pdf의 디펜던시에 pdfjs-dist 4.8.69 버전으로 되어 있어서 npm install pdfjs-dist@4.8.69 로 설치하고
// node_modules/pdfjs-dist/build/pdf.worker.mjs 를 복사해서 public/pdf/ 에 넣고 아래같이 불러서 사용
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf/pdf.worker.mjs';

const PdfViewer = ({ fileUrl }: { fileUrl: string }) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const containerRef = useRef<HTMLDivElement>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  // resize 시 동적으로 너비 조정
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize(); // 초기 실행
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (_, i) => (
          <Page key={`page_${i + 1}`} pageNumber={i + 1} width={width} />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;
